import styled from 'styled-components';

interface BTSelectItemProps {
    icon: React.ReactNode;
    text: string;
    selected?: boolean;
    onClick: () => void;
}

const BTSelectItem = ({ icon, text, selected = false, onClick }: BTSelectItemProps) => {
    return (
        <ItemContainer selected={selected} onClick={onClick}>
            <IconContainer>{icon}</IconContainer>
            <Text>{text}</Text>
        </ItemContainer>
    );
};

export default BTSelectItem;

const ItemContainer = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  margin: 0px 24px;
  width: 204px;
  border-radius: 4px;
  background-color: ${({ selected }) => (selected ? '#FFFFFF' : 'transparent')};
  color: ${({ selected }) => (selected ? '#6C757D' : '#FFFFFF')};
  cursor: pointer;
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 400;
`;
